import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var RotateCwIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M18.926 8a3 3 0 013 3v8a3 3 0 01-3 3h-8a3 3 0 01-3-3v-8a3 3 0 013-3zm0 2h-8a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1v-8a1 1 0 00-1-1zm-8.68-8.793l.093.085 1.963 2.056a1 1 0 01.07 1.3l-.08.092-1.916 1.946a1 1 0 01-1.508-1.308l.083-.095.276-.281a5 5 0 00-4.828 6.95 1 1 0 01-1.84.782A7 7 0 019.204 3l-.024-.025-.289-.301a1 1 0 01-.053-1.322l.086-.092a1 1 0 011.321-.053z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
RotateCwIcon.isCarinaIcon = true;
export default RotateCwIcon;
